import {App, Button, Flex} from "antd";
import React, {useEffect, useState} from "react";
import "./EditConcourseGroups.less"
import {IConcourseGroupsPriority, resultStore} from "../../../../store/admissions/admissionStore";
import Step3 from "../Step3";
import {postRequest} from "../../../../api/httpRequest";
import {useLocation, useNavigate} from "react-router";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import {stepsStore} from "../../../../store/admissions/stepperStore";


export default function EditConcourseGroupPriority() {

    const location = useLocation();
    const {result, setResult} = resultStore()
    const [sending, setSending] = useState(false);
    const {notification} = App.useApp();
    const navigate = useNavigate()
    const {stepsData, setStepsData} = stepsStore();
    const {xl} = useBreakpoint()

    useEffect(() => {

    }, []);

    const createRequest = () => {
        return {
            UID: location.state.statement,
            training: result.concourseGroupsPriority.map((item: IConcourseGroupsPriority) => {
                return {
                    CompetitionGroupCode: item.code,
                    Priority: item.priority,
                    Profiles: result.concourseGroupsPriority.find(concourseGroup => concourseGroup.code === item.code)?.profiles.map((profile, index) => {
                        return {
                            Code: profile.profilecode,
                            Priority: profile.priority,
                        }
                    })
                }
            })
        }
    }

    return (
        <Flex className={xl ? "admission-edit-page-priority" : "admission-edit-page-priority-mobile"} align="center"
              justify="center" gap={16} vertical={true}>
            <Step3/>
            <Flex style={{height: "20%"}} gap={16} justify={"space-between"}>
                <Button onClick={() => navigate(-1)}>Назад</Button>
                <Button
                    disabled={!stepsData.nextStep}
                    loading={sending}
                    type={"primary"}
                    onClick={() => {
                        postRequest("/server/proxy/contracts/ChangeCompetitionGroups", createRequest())
                            .then(response => {
                                setSending(false)
                                notification.success({
                                    message: `Конкурсные группы успешно отредактированы`,
                                    duration: 3
                                });
                                navigate("/admission")
                            })
                            .catch(error => {
                                setSending(false)
                                notification.error({
                                    message: `${JSON.stringify(error)}`,
                                    duration: 3
                                });
                            })
                    }}>Отправить изменения конкурсных групп</Button>
            </Flex>
        </Flex>
    )
}
